import { stripHtml } from "utils/formConfigUtils"
import * as Yup from "yup"

export const FIELDS_NAME = {
   ITEM: "item",
   NAME: "name",
   PRICE: "price",
   DESCRIPTION: "description",
   STATUS: "status",
   QUANTITY: "quantity",
   STATION_INVOLVED: "stationInvolved",
   ENHANCEMENT_TYPE: "enhancementType",
   SELLING_PRICE: "sellingPrice",
   IS_CUSTOMIZABLE: "isCustomizable",
   IS_POPULAR: "popular",
   TRAILER_TYPE: "trailerType",
}

export const TOGGLE_STATUS = {
   Yes: "Yes",
   No: "No",
}
export const ENHANCEMENT_TYPES = {
   Addition: "Addition",
   Replacement: "Replacement",
}

export const VARIATIONS = {
   Yes: "Yes",
   No: "No",
}

export const ADD_NOTE = {
   Yes: "Yes",
   No: "No",
}

export const initialValues = {
   [FIELDS_NAME.DESCRIPTION]: "",
   [FIELDS_NAME.PRICE]: "",
   [FIELDS_NAME.NAME]: "",
   [FIELDS_NAME.SELLING_PRICE]: "",
   [FIELDS_NAME.STATUS]: "INACTIVE",
   [FIELDS_NAME.IS_CUSTOMIZABLE]: "ACTIVE",
   [FIELDS_NAME.TRAILER_TYPE]: [],
}

export const packageItemInitialValues = {
   [FIELDS_NAME.ITEM]: null,
   [FIELDS_NAME.PRICE]: "",
   [FIELDS_NAME.NAME]: "",
   [FIELDS_NAME.SELLING_PRICE]: "",
   [FIELDS_NAME.QUANTITY]: "",
   [FIELDS_NAME.STATUS]: "ACTIVE",
   [FIELDS_NAME.STATION_INVOLVED]: null,
   [FIELDS_NAME.ENHANCEMENT_TYPE]: ENHANCEMENT_TYPES.Addition,
   [FIELDS_NAME.IS_POPULAR]: false,
}

export const validationSchema = Yup.object({
   [FIELDS_NAME.NAME]: Yup.string()
      .required("Enter item name")
      .min(1, "Name must be at least 1 characters")
      .max(100, "Name cannot be more than 100 characters"),
   [FIELDS_NAME.DESCRIPTION]: Yup.string()
      .nullable()
      .required("Description is required")
      .test("description-not-empty", "Description is required", value => {
         if (!value) return false
         const plainText = stripHtml(value).trim()
         return plainText.length > 0
      }),
   [FIELDS_NAME.STATUS]: Yup.string().required("Select status"),
   [FIELDS_NAME.IS_CUSTOMIZABLE]: Yup.string(),
   // [FIELDS_NAME.TRAILER_TYPE]: Yup.mixed().test(
   //    "trailerType",
   //    "Select at least one trailer type",
   //    value => {
   //       return Array.isArray(value) && value.length > 0
   //    }
   // ),
   [FIELDS_NAME.PRICE]: Yup.number("Enter numbers only")
      .required("Enter valid price")
      .test("", "Price must be between 1 and 8 numbers", item => {
         let num = item?.toString()?.length
         return num <= 8 && num >= 1
      }),
})

export const packageItemValidationSchema = Yup.object({
   [FIELDS_NAME.NAME]: Yup.string()
      .required("Enter item name")
      .min(1, "Name must be at least 1 characters")
      .max(100, "Name cannot be more than 100 characters"),
   [FIELDS_NAME.ITEM]: Yup.object()
      .required("Select item")
      .nullable("Select valid item"),
   [FIELDS_NAME.STATION_INVOLVED]: Yup.object()
      .required("Select station")
      .nullable("Select valid station"),
   [FIELDS_NAME.QUANTITY]: Yup.number("Enter quantity")
      .test("", "Quantity must be between 1 and 8 numbers", item => {
         let num = item?.toString()?.length
         return num <= 8 && num >= 1
      })
      .required(),
   [FIELDS_NAME.PRICE]: Yup.number("Enter numbers only")
      .required("Price needs to be added")
      .test("", "Price must be between 1 and 8 numbers", item => {
         let num = item?.toString()?.length
         return num <= 8 && num >= 1
      }),
   [FIELDS_NAME.SELLING_PRICE]: Yup.number("Enter numbers only")
      .required("Enter valid price")
      .test("", "Price must be between 1 and 8 numbers", item => {
         let num = item?.toString()?.length
         return num <= 8 && num >= 1
      }),
   [FIELDS_NAME.STATUS]: Yup.string().required("Select status"),
})
